<template>
  <BaseModal
    class="modal-print"
    title="Печать документов"
    @close="closeModalPrint"
  >
    <VForm
      class="d-flex flex-col"
      @request="createPrint"
    >
      <div class="mb-30">
        <VCheckbox
          v-model="checkRouteSheet"
          label="Маршрутный лист"
          class="mb-20"
        />

        <VCheckbox
          v-model="checkTaskForm"
          label="Бланк ТЗ"
          class="mb-20"
        />

        <VCheckbox
          v-model="checkPassportQuality"
          label="Паспорт"
          class="mb-20"
        />

        <VCheckbox
          v-model="checkBoxSlider"
          label="Стикер"
        />

        <VCheckbox
          v-if="permissionPrintDocsOffConsignment && isInnerReclamation"
          v-model="checkActMaterial"
          label="Акт на списание материала"
          class="mb-20 mt-20"
        />

        <VCheckbox
          v-if="permissionPrintDocsOffConsignment && isInnerReclamation"
          v-model="checkActInternalReclamation"
          label="Акт разбора внутренней рекламации"
        />
      </div>

      <VButton
        text="Печать"
        class="m-center"
        color="primary"
        size="l"
        type="submit"
        :loading="$store.state.isSendingRequestModal"
      />
    </VForm>
  </BaseModal>
</template>

<script>
import { openPrint } from '@/utils/print/openPrint'
import BaseModal from '@/components/ui/Modal/BaseModal'
import VForm from '@/components/Form/VForm'
import VCheckbox from '@/components/Form/VCheckbox'
import VButton from '@/components/simple/button/VButton'
import { showAlertWarning } from '@/utils/store/alert'
import { mapGetters } from 'vuex'
import mediaService from '@/services/media.service'

export default {
  name: 'ModalConsignmentPrint',
  components: {
    BaseModal,
    VForm,
    VButton,
    VCheckbox
  },
  props: {
    consignmentId: {
      type: [String, Number],
      required: true
    },
    isInnerReclamation: {
      type: Boolean,
      default: false
    },
    positionId: {
      type: [String, Number],
      required: true
    }
  },

  data: () => ({
    checkTaskForm: true,
    checkRouteSheet: true,
    checkPassportQuality: false,
    checkBoxSlider: false,
    checkActMaterial: false,
    checkActInternalReclamation: false
  }),

  computed: {
    ...mapGetters('permission', [
      'permissionPrintDocsOffConsignment'
    ])
  },

  methods: {
    async createPrint () {
      if (this.checkTaskForm
        || this.checkRouteSheet
        || this.checkActMaterial
        || this.checkActInternalReclamation
        || this.checkPassportQuality
        || this.checkBoxSlider) {
        await this.getPrintRequest()
      } else {
        showAlertWarning('Пожалуйста, выберете тип документа для печати')
      }
    },

    async getPrintRequest () {
      try {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL')

        const params = {
          consignment_ids: [this.consignmentId],
          position_id: this.positionId,
          stage: this.checkRouteSheet ? 'Y' : 'N',
          technical_task: this.checkTaskForm ? 'Y' : 'N',
          material_write_off: this.checkActMaterial ? 'Y' : 'N',
          investigation_reclamation: this.checkActInternalReclamation ? 'Y' : 'N',
          passport: this.checkPassportQuality ? 'Y' : 'N',
          box_slider: this.checkBoxSlider ? 'Y' : 'N'
        }

        const response = await openPrint('consignment-print', params)

        if (response?.status !== 200) return

        const data = mediaService.createFileFromResponse(response)
        this.$emit('request', data)
      } finally {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL', false)
      }
    },

    closeModalPrint () {
      this.$emit('close')
    }
  }
}
</script>
